var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"odr-table",style:(_vm.width && ("width: " + _vm.width + " !important;"))},[_c('tbody',{staticClass:"odr-table__tbody"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }